import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useConfirm } from 'material-ui-confirm';
import Grid from 'material/components/Grid';

import { campaignsSelectors } from 'store/selectors/campaigns';
import { deleteCustomTarget, fetchCustomTargets } from 'store/actions/campaigns';
import { setSnackbarSuccess } from 'store/actions/global';

import { Backdrop, BreadcrumbsNavigation, Callout, Container } from 'common/components';

import CustomTargetsTable from '../components/CustomTargetsTable';
import CustomTargetsTopCard from '../components/CustomTargetsTopCard';

const CustomTargets = () => {
  const dispatch = useDispatch();
  const { organizationUuid } = useParams();

  const { customTargets, isCustomTargetsFetching } = useSelector(state => ({
    customTargets: campaignsSelectors.getCustomTargets(state),
    isCustomTargetsFetching: campaignsSelectors.isCustomTargetsFetching(state),
  }));

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/campaigns`,
      name: 'Advocacy',
    },
    {
      link: '',
      name: 'Custom Targets',
    },
  ];

  useEffect(() => {
    dispatch(fetchCustomTargets({ organization: organizationUuid }));
  }, [dispatch, organizationUuid]);

  const confirm = useConfirm();

  const handleRemoveCustomTarget = customTargetUuid => {
    confirm({
      confirmationText: 'Remove',
      title: 'Remove Custom Target?',
    })
      .then(() => dispatch(deleteCustomTarget(customTargetUuid)))
      .then(() => dispatch(fetchCustomTargets({ organization: organizationUuid })))
      .then(() => dispatch(setSnackbarSuccess({ message: 'Custom target deleted.' })));
  };

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container>
        <Grid container>
          <CustomTargetsTopCard />
        </Grid>
        <Grid container>
          <Callout
            severity="info"
            sx={{
              mb: 2,
              width: '100%',
            }}
          >
            Approved custom targets can be added to action centers and target groups using the
            Individual target search feature.
          </Callout>
        </Grid>
        <Grid container>
          <CustomTargetsTable
            customTargets={customTargets}
            handleRemoveCustomTarget={handleRemoveCustomTarget}
            isLoading={isCustomTargetsFetching}
          />
        </Grid>
      </Container>
      <Backdrop isOpen={isCustomTargetsFetching} />
    </>
  );
};

export default CustomTargets;
